import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { Home, } from "lucide-react";


interface BreadcrumbProps {
    pageName: string;
}
const Breadcrumb: React.FC<BreadcrumbProps> = ({ pageName }: BreadcrumbProps) => {
    const nav = useNavigate();

    // const { i18n } = useTranslation();
    // @ts-ignore
    // const t = (txt: string) => i18n.t(txt);

    return (
        <>
            <nav className="breadcrumb-clean" aria-label="breadcrumb">
                <span className="crumb-link" onClick={() => nav("/")}>
                    <Home size={18} />
                </span>
                <span className="crumb-sep">/</span>
                <span className="crumb-current">{pageName}</span>
            </nav>
        </>
    );
}

export default Breadcrumb;